/* eslint-disable no-new */
import Swiper, {Navigation} from 'swiper';
import helpers from '../helpers';

Swiper.use([Navigation]);

class PartnersSlider {
	constructor(section) {
		this.wrapper = section;
		this.slider = this.wrapper.querySelector('.partners-slider__slider');
		this.btnPrev = '.partners-slider__btn-prev';
		this.btnNext = '.partners-slider__btn-next';
		this.btnShowMOre = this.wrapper.querySelector('.partners-slider__show-more');
		this.allSlides = this.wrapper.getElementsByClassName('swiper-slide');
		this.numberShowMore = 10;
		this.params = {
			direction: 'horizontal',
			speed: 750,
			slidesPerView: 3,
			spaceBetween: 20,
			slidesPerGroup: 3,
			loop: true,

			navigation: {
				nextEl: this.btnNext,
				prevEl: this.btnPrev,
			},
			breakpoints: {
				768: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					spaceBetween: 50,
				},
				1024: {
					slidesPerView: 6,
					slidesPerGroup: 3,
					spaceBetween: 50,
				},
			},
		};
		this.btnShowMOre.onclick = this.showMore.bind(this);
		this.showMoreInit = false;
		this.init();
	}

	// eslint-disable-next-line
	update(slider) {
		// if (window.innerWidth < 768) {
		// 	slider.disable();
		// } else {
		// 	slider.enable();
		// }
	}

	setHeightShowMore() {
		if (!helpers.isMobile() && this.showMoreInit) {
			for (let i = 0; i < this.allSlides.length; i++) {
				this.allSlides[i].style.display = 'block';
				this.btnShowMOre.style.display = 'none';
			}
			this.showMoreInit = false;
		} else if (!this.showMoreInit) {
			const wrapper = this.allSlides[0].closest('.swiper-wrapper');

			for (let i = 0; i < this.allSlides.length; i++) {
				const wrapperOffset = wrapper.getBoundingClientRect().top + this.allSlides[i].clientHeight + 30;
				const elOffset = this.allSlides[i].getBoundingClientRect().top;

				if (elOffset <= wrapperOffset) {
					this.allSlides[i].style.display = 'block';
					this.btnShowMOre.style.display = 'none';
				} else if (elOffset > wrapperOffset) {
					this.allSlides[i].style.display = 'none';
					this.btnShowMOre.style.display = 'flex';
				}
			}

			this.showMoreInit = true;
		}
	}

	showMore() {
		let counter = 1;

		for (let i = 0; i < this.allSlides.length; i++) {
			if (getComputedStyle(this.allSlides[i]).display === 'none') {
				this.allSlides[i].style.display = 'block';
				counter++;

				if (i + 1 === this.allSlides.length) {
					this.btnShowMOre.style.display = 'none';
				}

				if (counter > this.numberShowMore) {
					break;
				}
			}
		}
	}

	init() {
		const slider = new Swiper(this.slider, this.params);

		window.addEventListener('resize', () => {
			this.update(slider);
			setTimeout(() => this.setHeightShowMore(), 500);
		});

		this.update(slider);
		if (helpers.isMobile()) {
			setTimeout(() => this.setHeightShowMore(), 500);
		}
	}
}

function init() {
	const partnerSlider = document.querySelector('.partners-slider');
	if (partnerSlider) {
		new PartnersSlider(partnerSlider);
	}
}

export default {
	init,
};
